module.exports = __webpack_public_path__ + "static/media/AUTO-on.a2d8343a.svg";